import * as firebase from 'firebase';

let config = {
  apiKey: "AIzaSyA3VjgSBY_ntJ9_zuwwVc6i9VO9BBqCl0E",
     authDomain: "bgipttve.firebaseapp.com",
     databaseURL: "https://bgipttve.firebaseio.com",
     projectId: "bgipttve",
     storageBucket: "bgipttve.appspot.com",
     messagingSenderId: "568308670735"
};
firebase.initializeApp(config);


let database = firebase.database();
export default database;



// WEBPACK FOOTER //
// ./src/helpers/firebase.js